import { render } from "./refresh-page.vue?vue&type=template&id=f832a7f0&scoped=true"
import script from "./refresh-page.vue?vue&type=script&lang=js"
export * from "./refresh-page.vue?vue&type=script&lang=js"

import "./refresh-page.vue?vue&type=style&index=0&id=f832a7f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f832a7f0"]])

export default __exports__